import type { Query } from '@tanstack/react-query';
import i18n from 'i18next';
import { showSnackbarError } from '../notifications.ts';
import { getApiErrorMessage } from './httpErrors.ts';

export const onQueryError = (error: Error, query?: Query<unknown, unknown, unknown>) => {
  // biome-ignore lint/suspicious/noConsole: logging error in console
  console.error(error);

  if (query?.meta?.disableNotification) {
    return;
  }

  const metaErrorMessage = query?.meta?.errorMessage;
  const apiErrorMessage = getApiErrorMessage(error);
  const defaultErrorMessage = i18n.t('Fetching data failed.');

  const errorMessage = metaErrorMessage || apiErrorMessage || defaultErrorMessage;

  showSnackbarError(errorMessage);
};
